export default "__VITE_ASSET__A$MzVhXZ__"